export const FIELDS = {
  NAME: 'name',
  CARD_PROVIDER: 'cardProvider',
  CARD_NUMBER: 'cardNumber',
  CARD_NIP: 'cardNip',
  EXPIRATION_MONTH: 'expirationMonth',
  EXPIRATION_YEAR: 'expirationYear',
  ADDRESS: 'address',
  CITY: 'city',
  STATE: 'state',
  ZIP_CODE: 'zipCode',
  PHONE: 'phone',
};
export const NIP_ERROR_MESSAGE =
  'El campo codigo de seguridad debe ser de 3 o 4 digitos';
export const PHONE_ERROR_MESSAGE = 'El telefono debe tener 10 digitos';
export const EMPTY_NAME = 'error_nombre_vacio';
export const ONLY_LETTERS = 'Utiliza solo letras';
export const ONLY_NUMBERS = 'Utiliza solo numeros';
export const INVALID_CC_HOLDER = 'invalid_cc_holder';
export const INVALID_CC_TYPE = 'invalid_cc_type';
export const INVALID_CC_NUMBER = 'invalid_cc_number';
export const INVALID_CC_DATE = 'error_fecha_invalida_tc';
export const EMPTY_ADDRESS = 'error_direccion_vacia';
export const EMPTY_CITY = 'error_ciudad_vacia';
export const EMPTY_STATE = 'error_estado_vacio';
export const EMPTY_ZIP_CODE = 'error_cp_vacio';
export const EMPTY_PHONE = 'error_telefono_vacio';
